/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { useContentRecommendation } from '@/data/Content/ContentRecommendation';
import { Box } from '@mui/material';
import { FC } from 'react';

const BOTTOM_RIGHT_EMS_NAME = 'DPV2_ContentRecommendation_PDP_BottomRight_Spot';

export const SpotBottomRight: FC = () => {
	const { data } = useContentRecommendation(BOTTOM_RIGHT_EMS_NAME);

	// Avoid reserving empty space (the "hueco") when the spot has no content.
	if (!data || data.length === 0) {
		return null;
	}

	return (
		<Box mt={'10px'}>
			<ContentRecommendation
				id="pdp-bottom-right-content-recommendation"
				properties={{
					emsName: BOTTOM_RIGHT_EMS_NAME,
				}}
			/>
		</Box>
	);
};

export const SpotBackToSchool: FC = () => (
	<ContentRecommendation
		id="pdp-back-to-school-content-recommendation"
		properties={{
			emsName: `DPV2_ContentRecommendation_PDP_BackToSchool_Spot`,
		}}
	/>
);

export const SpotCarousels: FC = () => (
	<ContentRecommendation
		id="pdp-carousel-content-recommendation"
		properties={{
			emsName: `DPV2_ContentRecommendation_PDP_Carousels_Spot`,
		}}
	/>
);
